import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { ASSETS } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
 const [email, setEmail] = useState("");
 const [loading, setLoading] = useState(false);

 const submit = async (e) => {
 e.preventDefault();
 if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
 toast.error("Please enter a valid email address.");
 return;
 }
 setLoading(true);
 try {
 const { data } = await axios.post(`${API}/newsletter`, { email });
 if (data.status === "already_subscribed") {
 toast("You're already on the list, see you in 2026.");
 } else {
 toast.success("You're on the list. We'll be in touch when the edition launches.");
 }
 setEmail("");
 } catch {
 toast.error("Something went wrong, please try again.");
 } finally {
 setLoading(false);
 }
 };

 return (
 <section id="newsletter" data-testid="newsletter" className="relative overflow-hidden">
 <img src={ASSETS.gumtree} alt="" aria-hidden className="absolute inset-0 h-full w-full scale-105 object-cover blur-[1.5px]" />
 <div className="absolute inset-0 bg-gradient-to-b from-forest/90 via-forest/88 to-ink/95" />
 <div className="relative mx-auto max-w-[900px] px-5 py-24 text-center md:px-10 md:py-32">
 <span className="font-body text-xs uppercase tracking-[0.3em] text-ochre">Stay in the loop</span>
 <h2 className="mx-auto mt-4 max-w-2xl font-display text-4xl font-medium leading-[1.08] text-cream sm:text-5xl">
 Get notified when the 2026 edition launches.
 </h2>
 <p className="mx-auto mt-5 max-w-xl font-body text-base text-cream/75">
 No spam, just word when the Almanac goes to print, and how to get a copy in your hands.
 </p>

 <form onSubmit={submit} data-testid="newsletter-form" className="mx-auto mt-9 flex max-w-md flex-col gap-3 sm:flex-row">
 <input
 data-testid="newsletter-email"
 type="email"
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 placeholder="you@example.com"
 className="w-full rounded-full border border-cream/30 bg-cream/10 px-6 py-3.5 font-body text-sm text-cream placeholder:text-cream/50 outline-none transition-colors focus:border-ochre"
 />
 <button
 type="submit"
 disabled={loading}
 data-testid="newsletter-submit"
 className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-ochre px-7 py-3.5 font-body text-sm font-medium text-forest transition-all duration-300 hover:bg-cream disabled:opacity-60"
 >
 {loading ? <Loader2 size={16} className="animate-spin" /> : <>Notify me <Send size={15} /></>}
 </button>
 </form>
 </div>
 </section>
 );
};
